import { n as e, t } from "./apiUrls-D1kwi47F.js";
import * as n from "zod";
//#region src/generated/core/bodySerializer.gen.ts
var r = { bodySerializer: (e) => JSON.stringify(e, (e, t) => typeof t == "bigint" ? t.toString() : t) };
Object.entries({
	$body_: "body",
	$headers_: "headers",
	$path_: "path",
	$query_: "query"
});
//#endregion
//#region src/generated/core/serverSentEvents.gen.ts
var i = ({ onRequest: e, onSseError: t, onSseEvent: n, responseTransformer: r, responseValidator: i, sseDefaultRetryDelay: a, sseMaxRetryAttempts: o, sseMaxRetryDelay: s, sseSleepFn: c, url: l, ...u }) => {
	let d, f = c ?? ((e) => new Promise((t) => setTimeout(t, e)));
	return { stream: async function* () {
		let c = a ?? 3e3, p = 0, m = u.signal ?? new AbortController().signal;
		for (; !m.aborted;) {
			p++;
			let a = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
			d !== void 0 && a.set("Last-Event-ID", d);
			try {
				let t = {
					redirect: "follow",
					...u,
					body: u.serializedBody,
					headers: a,
					signal: m
				}, o = new Request(l, t);
				e && (o = await e(l, t));
				let s = await (u.fetch ?? globalThis.fetch)(o);
				if (!s.ok) throw Error(`SSE failed: ${s.status} ${s.statusText}`);
				if (!s.body) throw Error("No body in SSE response");
				let f = s.body.pipeThrough(new TextDecoderStream()).getReader(), p = "", h = () => {
					try {
						f.cancel();
					} catch {}
				};
				m.addEventListener("abort", h);
				try {
					for (;;) {
						let { done: e, value: t } = await f.read();
						if (e) break;
						p += t, p = p.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
						let a = p.split("\n\n");
						p = a.pop() ?? "";
						for (let e of a) {
							let t = e.split("\n"), a = [], o;
							for (let e of t) if (e.startsWith("data:")) a.push(e.replace(/^data:\s*/, ""));
							else if (e.startsWith("event:")) o = e.replace(/^event:\s*/, "");
							else if (e.startsWith("id:")) d = e.replace(/^id:\s*/, "");
							else if (e.startsWith("retry:")) {
								let t = Number.parseInt(e.replace(/^retry:\s*/, ""), 10);
								Number.isNaN(t) || (c = t);
							}
							let s, l = !1;
							if (a.length) {
								let e = a.join("\n");
								try {
									s = JSON.parse(e), l = !0;
								} catch {
									s = e;
								}
							}
							l && (i && await i(s), r && (s = await r(s))), n?.({
								data: s,
								event: o,
								id: d,
								retry: c
							}), a.length && (yield s);
						}
					}
				} finally {
					m.removeEventListener("abort", h), f.releaseLock();
				}
				break;
			} catch (e) {
				if (t?.(e), o !== void 0 && p >= o) break;
				let n = Math.min(c * 2 ** (p - 1), s ?? 3e4);
				await f(n);
			}
		}
	}() };
}, a = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, o = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, s = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, c = ({ allowReserved: e, explode: t, name: n, style: r, value: i }) => {
	if (!t) {
		let t = (e ? i : i.map((e) => encodeURIComponent(e))).join(o(r));
		switch (r) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let s = a(r), c = i.map((t) => r === "label" || r === "simple" ? e ? t : encodeURIComponent(t) : l({
		allowReserved: e,
		name: n,
		value: t
	})).join(s);
	return r === "label" || r === "matrix" ? s + c : c;
}, l = ({ allowReserved: e, name: t, value: n }) => {
	if (n == null) return "";
	if (typeof n == "object") throw Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
	return `${t}=${e ? n : encodeURIComponent(n)}`;
}, u = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: a }) => {
	if (i instanceof Date) return a ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let o = s(r), c = Object.entries(i).map(([t, i]) => l({
		allowReserved: e,
		name: r === "deepObject" ? `${n}[${t}]` : t,
		value: i
	})).join(o);
	return r === "label" || r === "matrix" ? o + c : c;
}, d = /\{[^{}]+\}/g, f = ({ path: e, url: t }) => {
	let n = t, r = t.match(d);
	if (r) for (let t of r) {
		let r = !1, i = t.substring(1, t.length - 1), a = "simple";
		i.endsWith("*") && (r = !0, i = i.substring(0, i.length - 1)), i.startsWith(".") ? (i = i.substring(1), a = "label") : i.startsWith(";") && (i = i.substring(1), a = "matrix");
		let o = e[i];
		if (o == null) continue;
		if (Array.isArray(o)) {
			n = n.replace(t, c({
				explode: r,
				name: i,
				style: a,
				value: o
			}));
			continue;
		}
		if (typeof o == "object") {
			n = n.replace(t, u({
				explode: r,
				name: i,
				style: a,
				value: o,
				valueOnly: !0
			}));
			continue;
		}
		if (a === "matrix") {
			n = n.replace(t, `;${l({
				name: i,
				value: o
			})}`);
			continue;
		}
		let s = encodeURIComponent(a === "label" ? `.${o}` : o);
		n = n.replace(t, s);
	}
	return n;
}, p = ({ baseUrl: e, path: t, query: n, querySerializer: r, url: i }) => {
	let a = i.startsWith("/") ? i : `/${i}`, o = (e ?? "") + a;
	t && (o = f({
		path: t,
		url: o
	}));
	let s = n ? r(n) : "";
	return s.startsWith("?") && (s = s.substring(1)), s && (o += `?${s}`), o;
};
function m(e) {
	let t = e.body !== void 0;
	if (t && e.bodySerializer) return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body === "" ? null : e.body;
	if (t) return e.body;
}
//#endregion
//#region src/generated/core/auth.gen.ts
var h = async (e, t) => {
	let n = typeof t == "function" ? await t(e) : t;
	if (n) return e.scheme === "bearer" ? `Bearer ${n}` : e.scheme === "basic" ? `Basic ${btoa(n)}` : n;
}, g = ({ parameters: e = {}, ...t } = {}) => (n) => {
	let r = [];
	if (n && typeof n == "object") for (let i in n) {
		let a = n[i];
		if (a == null) continue;
		let o = e[i] || t;
		if (Array.isArray(a)) {
			let e = c({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "form",
				value: a,
				...o.array
			});
			e && r.push(e);
		} else if (typeof a == "object") {
			let e = u({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "deepObject",
				value: a,
				...o.object
			});
			e && r.push(e);
		} else {
			let e = l({
				allowReserved: o.allowReserved,
				name: i,
				value: a
			});
			e && r.push(e);
		}
	}
	return r.join("&");
}, ee = (e) => {
	if (!e) return "stream";
	let t = e.split(";")[0]?.trim();
	if (t) {
		if (t.startsWith("application/json") || t.endsWith("+json")) return "json";
		if (t === "multipart/form-data") return "formData";
		if ([
			"application/",
			"audio/",
			"image/",
			"video/"
		].some((e) => t.startsWith(e))) return "blob";
		if (t.startsWith("text/")) return "text";
	}
}, te = (e, t) => t ? !!(e.headers.has(t) || e.query?.[t] || e.headers.get("Cookie")?.includes(`${t}=`)) : !1, ne = async ({ security: e, ...t }) => {
	for (let n of e) {
		if (te(t, n.name)) continue;
		let e = await h(n, t.auth);
		if (!e) continue;
		let r = n.name ?? "Authorization";
		switch (n.in) {
			case "query":
				t.query ||= {}, t.query[r] = e;
				break;
			case "cookie":
				t.headers.append("Cookie", `${r}=${e}`);
				break;
			default: t.headers.set(r, e);
		}
	}
}, _ = (e) => p({
	baseUrl: e.baseUrl,
	path: e.path,
	query: e.query,
	querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : g(e.querySerializer),
	url: e.url
}), v = (e, t) => {
	let n = {
		...e,
		...t
	};
	return n.baseUrl?.endsWith("/") && (n.baseUrl = n.baseUrl.substring(0, n.baseUrl.length - 1)), n.headers = y(e.headers, t.headers), n;
}, re = (e) => {
	let t = [];
	return e.forEach((e, n) => {
		t.push([n, e]);
	}), t;
}, y = (...e) => {
	let t = new Headers();
	for (let n of e) {
		if (!n) continue;
		let e = n instanceof Headers ? re(n) : Object.entries(n);
		for (let [n, r] of e) if (r === null) t.delete(n);
		else if (Array.isArray(r)) for (let e of r) t.append(n, e);
		else r !== void 0 && t.set(n, typeof r == "object" ? JSON.stringify(r) : r);
	}
	return t;
}, b = class {
	fns = [];
	clear() {
		this.fns = [];
	}
	eject(e) {
		let t = this.getInterceptorIndex(e);
		this.fns[t] && (this.fns[t] = null);
	}
	exists(e) {
		let t = this.getInterceptorIndex(e);
		return !!this.fns[t];
	}
	getInterceptorIndex(e) {
		return typeof e == "number" ? this.fns[e] ? e : -1 : this.fns.indexOf(e);
	}
	update(e, t) {
		let n = this.getInterceptorIndex(e);
		return this.fns[n] ? (this.fns[n] = t, e) : !1;
	}
	use(e) {
		return this.fns.push(e), this.fns.length - 1;
	}
}, ie = () => ({
	error: new b(),
	request: new b(),
	response: new b()
}), ae = g({
	allowReserved: !1,
	array: {
		explode: !0,
		style: "form"
	},
	object: {
		explode: !0,
		style: "deepObject"
	}
}), oe = { "Content-Type": "application/json" }, x = (e = {}) => ({
	...r,
	headers: oe,
	parseAs: "auto",
	querySerializer: ae,
	...e
}), S = ((e = {}) => {
	let t = v(x(), e), n = () => ({ ...t }), r = (e) => (t = v(t, e), n()), a = ie(), o = async (e) => {
		let n = {
			...t,
			...e,
			fetch: e.fetch ?? t.fetch ?? globalThis.fetch,
			headers: y(t.headers, e.headers),
			serializedBody: void 0
		};
		return n.security && await ne({
			...n,
			security: n.security
		}), n.requestValidator && await n.requestValidator(n), n.body !== void 0 && n.bodySerializer && (n.serializedBody = n.bodySerializer(n.body)), (n.body === void 0 || n.serializedBody === "") && n.headers.delete("Content-Type"), {
			opts: n,
			url: _(n)
		};
	}, s = async (e) => {
		let { opts: t, url: n } = await o(e), r = {
			redirect: "follow",
			...t,
			body: m(t)
		}, i = new Request(n, r);
		for (let e of a.request.fns) e && (i = await e(i, t));
		let s = t.fetch, c;
		try {
			c = await s(i);
		} catch (e) {
			let n = e;
			for (let r of a.error.fns) r && (n = await r(e, void 0, i, t));
			if (n ||= {}, t.throwOnError) throw n;
			return t.responseStyle === "data" ? void 0 : {
				error: n,
				request: i,
				response: void 0
			};
		}
		for (let e of a.response.fns) e && (c = await e(c, i, t));
		let l = {
			request: i,
			response: c
		};
		if (c.ok) {
			let e = (t.parseAs === "auto" ? ee(c.headers.get("Content-Type")) : t.parseAs) ?? "json";
			if (c.status === 204 || c.headers.get("Content-Length") === "0") {
				let n;
				switch (e) {
					case "arrayBuffer":
					case "blob":
					case "text":
						n = await c[e]();
						break;
					case "formData":
						n = new FormData();
						break;
					case "stream":
						n = c.body;
						break;
					default: n = {};
				}
				return t.responseStyle === "data" ? n : {
					data: n,
					...l
				};
			}
			let n;
			switch (e) {
				case "arrayBuffer":
				case "blob":
				case "formData":
				case "text":
					n = await c[e]();
					break;
				case "json": {
					let e = await c.text();
					n = e ? JSON.parse(e) : {};
					break;
				}
				case "stream": return t.responseStyle === "data" ? c.body : {
					data: c.body,
					...l
				};
			}
			return e === "json" && (t.responseValidator && await t.responseValidator(n), t.responseTransformer && (n = await t.responseTransformer(n))), t.responseStyle === "data" ? n : {
				data: n,
				...l
			};
		}
		let u = await c.text(), d;
		try {
			d = JSON.parse(u);
		} catch {}
		let f = d ?? u, p = f;
		for (let e of a.error.fns) e && (p = await e(f, c, i, t));
		if (p ||= {}, t.throwOnError) throw p;
		return t.responseStyle === "data" ? void 0 : {
			error: p,
			...l
		};
	}, c = (e) => (t) => s({
		...t,
		method: e
	}), l = (e) => async (t) => {
		let { opts: n, url: r } = await o(t);
		return i({
			...n,
			body: n.body,
			headers: n.headers,
			method: e,
			onRequest: async (e, t) => {
				let r = new Request(e, t);
				for (let e of a.request.fns) e && (r = await e(r, n));
				return r;
			},
			serializedBody: m(n),
			url: r
		});
	};
	return {
		buildUrl: (e) => _({
			...t,
			...e
		}),
		connect: c("CONNECT"),
		delete: c("DELETE"),
		get: c("GET"),
		getConfig: n,
		head: c("HEAD"),
		interceptors: a,
		options: c("OPTIONS"),
		patch: c("PATCH"),
		post: c("POST"),
		put: c("PUT"),
		request: s,
		setConfig: r,
		sse: {
			connect: l("CONNECT"),
			delete: l("DELETE"),
			get: l("GET"),
			head: l("HEAD"),
			options: l("OPTIONS"),
			patch: l("PATCH"),
			post: l("POST"),
			put: l("PUT"),
			trace: l("TRACE")
		},
		trace: c("TRACE")
	};
})(x({
	baseUrl: "https://printing.api.myparcel.nl",
	throwOnError: !0
})), se = n.object({
	id: n.uuid().register(n.globalRegistry, { description: "Printer group ID." }),
	name: n.string().min(1).max(255).register(n.globalRegistry, { description: "Printer group name." }),
	shopIds: n.array(n.string().min(1).max(50)).min(1).max(100).register(n.globalRegistry, { description: "Shop IDs that can access this printer group." }),
	a4PrinterId: n.uuid().register(n.globalRegistry, { description: "A4 printer ID." }).optional(),
	a6PrinterId: n.uuid().register(n.globalRegistry, { description: "A6 printer ID." }).optional()
}), ce = n.object({
	id: n.uuid(),
	name: n.string().min(0).max(255),
	formats: n.array(n.enum(["A4", "A6"])).min(1).max(2)
});
n.object({
	type: n.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]).register(n.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: n.union([
		n.literal(400),
		n.literal(401),
		n.literal(404),
		n.literal(415),
		n.literal(500)
	]).register(n.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: n.string().min(1).max(100).register(n.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: n.string().min(1).max(5e3).register(n.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: n.url().register(n.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: n.unknown().register(n.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}).and(n.object({
	type: n.enum(["urn:problem:invalid-request-syntax"]).register(n.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: n.literal(400).register(n.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: n.array(n.object({
		detail: n.string().min(1).max(5e3),
		pointer: n.string().min(1).max(200).register(n.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).min(1).register(n.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
}));
var le = n.object({
	body: n.never().optional(),
	path: n.never().optional(),
	query: n.never().optional()
});
n.object({ results: n.array(se).min(0).max(250) }).register(n.globalRegistry, { description: "List of accessible printer groups" });
var ue = n.object({
	body: n.never().optional(),
	path: n.never().optional(),
	query: n.never().optional()
});
n.object({ results: n.array(ce).min(0).max(250) }).register(n.globalRegistry, { description: "List of printers" });
var de = n.object({
	body: n.never().optional(),
	path: n.never().optional(),
	query: n.never().optional()
});
n.object({ status: n.enum([
	"INITIALIZATION_REQUIRED",
	"ACTIVE",
	"SUSPENDED"
]) }).register(n.globalRegistry, { description: "Account status" });
var fe = n.object({
	body: n.object({
		printerGroupId: n.uuid().register(n.globalRegistry, { description: "Printer group ID." }),
		shopIds: n.array(n.string().min(1).max(50)).min(1).max(100).register(n.globalRegistry, { description: "Shop IDs that can access this printer group." })
	}).register(n.globalRegistry, { description: "Body for allowing shop IDs to access a printer group." }),
	path: n.never().optional(),
	query: n.never().optional()
});
n.void().register(n.globalRegistry, { description: "The shop IDs have access to the printer group." });
var C = n.object({
	body: n.object({
		printerGroupId: n.uuid().register(n.globalRegistry, { description: "Printer group ID." }),
		printerId: n.uuid().register(n.globalRegistry, { description: "Printer ID." }),
		format: n.enum(["A4", "A6"]).register(n.globalRegistry, { description: "Designated format of the printer." })
	}).register(n.globalRegistry, { description: "Body for assigning a printer to a printer group." }),
	path: n.never().optional(),
	query: n.never().optional()
});
n.void().register(n.globalRegistry, { description: "The printer has been assigned." });
var w = n.object({
	body: n.object({
		name: n.string().min(1).max(255).register(n.globalRegistry, { description: "Printer group name." }),
		shopIds: n.array(n.string().min(1).max(50)).min(1).max(100).register(n.globalRegistry, { description: "Shop IDs that can access this printer group." }),
		a4PrinterId: n.uuid().register(n.globalRegistry, { description: "A4 printer ID." }).optional(),
		a6PrinterId: n.uuid().register(n.globalRegistry, { description: "A6 printer ID." }).optional()
	}).register(n.globalRegistry, { description: "Body for creating a printer group." }),
	path: n.never().optional(),
	query: n.never().optional()
});
n.object({
	id: n.uuid().register(n.globalRegistry, { description: "Printer group ID." }),
	createdAt: n.iso.datetime().register(n.globalRegistry, { description: "Printer group created at." }),
	name: n.string().min(1).max(255).register(n.globalRegistry, { description: "Printer group name." }),
	shopIds: n.array(n.string().min(1).max(50)).min(1).max(100).register(n.globalRegistry, { description: "Shop IDs that can access this printer group." }),
	a4PrinterId: n.uuid().register(n.globalRegistry, { description: "A4 printer ID." }).optional(),
	a6PrinterId: n.uuid().register(n.globalRegistry, { description: "A6 printer ID." }).optional()
}).register(n.globalRegistry, { description: "The created printer group." });
var T = n.object({
	body: n.never().optional(),
	path: n.never().optional(),
	query: n.never().optional()
});
n.object({ credentials: n.object({
	email: n.email().max(64),
	password: n.string().min(8).max(32)
}) }).register(n.globalRegistry, { description: "The account has been enabled." });
var E = n.object({
	body: n.object({ printerGroupId: n.uuid().register(n.globalRegistry, { description: "Printer group ID." }) }).register(n.globalRegistry, { description: "Body for removing a printer group." }),
	path: n.never().optional(),
	query: n.never().optional()
});
n.void().register(n.globalRegistry, { description: "The printer group has been removed." });
var D = n.object({
	body: n.object({
		printerGroupId: n.uuid().register(n.globalRegistry, { description: "Printer group ID." }),
		name: n.string().min(1).max(255).register(n.globalRegistry, { description: "New printer group name." })
	}).register(n.globalRegistry, { description: "Body for renaming a printer group." }),
	path: n.never().optional(),
	query: n.never().optional()
});
n.object({
	id: n.uuid().register(n.globalRegistry, { description: "Printer group ID." }),
	name: n.string().min(1).max(255).register(n.globalRegistry, { description: "Printer group name." })
}).register(n.globalRegistry, { description: "Rename successful" });
var O = n.object({
	body: n.never().optional(),
	path: n.never().optional(),
	query: n.never().optional()
}), k = n.object({
	body: n.object({
		printerGroupId: n.uuid().register(n.globalRegistry, { description: "Printer group ID." }),
		format: n.enum(["A4", "A6"]).register(n.globalRegistry, { description: "Designated format of the printer." })
	}).register(n.globalRegistry, { description: "Body for unassigning a printer from a printer group." }),
	path: n.never().optional(),
	query: n.never().optional()
});
n.void().register(n.globalRegistry, { description: "The printer has been unassigned." });
//#endregion
//#region src/generated/zod-response.gen.ts
var A = n.object({
	id: n.uuid().register(n.globalRegistry, { description: "Printer group ID." }),
	name: n.string().register(n.globalRegistry, { description: "Printer group name." }),
	shopIds: n.array(n.string()).register(n.globalRegistry, { description: "Shop IDs that can access this printer group." }),
	a4PrinterId: n.uuid().register(n.globalRegistry, { description: "A4 printer ID." }).optional(),
	a6PrinterId: n.uuid().register(n.globalRegistry, { description: "A6 printer ID." }).optional()
}), j = n.object({
	id: n.uuid(),
	name: n.string(),
	formats: n.array(n.union([n.enum(["A4", "A6"]), n.string()]))
});
n.object({
	type: n.union([n.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]), n.string()]).register(n.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: n.union([
		n.literal(400),
		n.literal(401),
		n.literal(404),
		n.literal(415),
		n.literal(500)
	]).register(n.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: n.string().register(n.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: n.string().register(n.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: n.url().register(n.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: n.unknown().register(n.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}).and(n.object({
	type: n.union([n.enum(["urn:problem:invalid-request-syntax"]), n.string()]).register(n.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: n.literal(400).register(n.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: n.array(n.object({
		detail: n.string(),
		pointer: n.string().register(n.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).register(n.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), n.object({
	body: n.never().optional(),
	path: n.never().optional(),
	query: n.never().optional()
});
var M = n.object({ results: n.array(A) }).register(n.globalRegistry, { description: "List of accessible printer groups" });
n.object({
	body: n.never().optional(),
	path: n.never().optional(),
	query: n.never().optional()
});
var N = n.object({ results: n.array(j) }).register(n.globalRegistry, { description: "List of printers" });
n.object({
	body: n.never().optional(),
	path: n.never().optional(),
	query: n.never().optional()
});
var P = n.object({ status: n.union([n.enum([
	"INITIALIZATION_REQUIRED",
	"ACTIVE",
	"SUSPENDED"
]), n.string()]) }).register(n.globalRegistry, { description: "Account status" });
n.object({
	body: n.object({
		printerGroupId: n.uuid().register(n.globalRegistry, { description: "Printer group ID." }),
		shopIds: n.array(n.string()).register(n.globalRegistry, { description: "Shop IDs that can access this printer group." })
	}).register(n.globalRegistry, { description: "Body for allowing shop IDs to access a printer group." }),
	path: n.never().optional(),
	query: n.never().optional()
});
var F = n.void().register(n.globalRegistry, { description: "The shop IDs have access to the printer group." });
n.object({
	body: n.object({
		printerGroupId: n.uuid().register(n.globalRegistry, { description: "Printer group ID." }),
		printerId: n.uuid().register(n.globalRegistry, { description: "Printer ID." }),
		format: n.union([n.enum(["A4", "A6"]), n.string()]).register(n.globalRegistry, { description: "Designated format of the printer." })
	}).register(n.globalRegistry, { description: "Body for assigning a printer to a printer group." }),
	path: n.never().optional(),
	query: n.never().optional()
});
var I = n.void().register(n.globalRegistry, { description: "The printer has been assigned." });
n.object({
	body: n.object({
		name: n.string().register(n.globalRegistry, { description: "Printer group name." }),
		shopIds: n.array(n.string()).register(n.globalRegistry, { description: "Shop IDs that can access this printer group." }),
		a4PrinterId: n.uuid().register(n.globalRegistry, { description: "A4 printer ID." }).optional(),
		a6PrinterId: n.uuid().register(n.globalRegistry, { description: "A6 printer ID." }).optional()
	}).register(n.globalRegistry, { description: "Body for creating a printer group." }),
	path: n.never().optional(),
	query: n.never().optional()
});
var L = n.object({
	id: n.uuid().register(n.globalRegistry, { description: "Printer group ID." }),
	createdAt: n.iso.datetime().register(n.globalRegistry, { description: "Printer group created at." }),
	name: n.string().register(n.globalRegistry, { description: "Printer group name." }),
	shopIds: n.array(n.string()).register(n.globalRegistry, { description: "Shop IDs that can access this printer group." }),
	a4PrinterId: n.uuid().register(n.globalRegistry, { description: "A4 printer ID." }).optional(),
	a6PrinterId: n.uuid().register(n.globalRegistry, { description: "A6 printer ID." }).optional()
}).register(n.globalRegistry, { description: "The created printer group." });
n.object({
	body: n.never().optional(),
	path: n.never().optional(),
	query: n.never().optional()
});
var R = n.object({ credentials: n.object({
	email: n.email().max(64),
	password: n.string()
}) }).register(n.globalRegistry, { description: "The account has been enabled." });
n.object({
	body: n.object({ printerGroupId: n.uuid().register(n.globalRegistry, { description: "Printer group ID." }) }).register(n.globalRegistry, { description: "Body for removing a printer group." }),
	path: n.never().optional(),
	query: n.never().optional()
});
var z = n.void().register(n.globalRegistry, { description: "The printer group has been removed." });
n.object({
	body: n.object({
		printerGroupId: n.uuid().register(n.globalRegistry, { description: "Printer group ID." }),
		name: n.string().register(n.globalRegistry, { description: "New printer group name." })
	}).register(n.globalRegistry, { description: "Body for renaming a printer group." }),
	path: n.never().optional(),
	query: n.never().optional()
});
var B = n.object({
	id: n.uuid().register(n.globalRegistry, { description: "Printer group ID." }),
	name: n.string().register(n.globalRegistry, { description: "Printer group name." })
}).register(n.globalRegistry, { description: "Rename successful" });
n.object({
	body: n.never().optional(),
	path: n.never().optional(),
	query: n.never().optional()
}), n.object({
	body: n.object({
		printerGroupId: n.uuid().register(n.globalRegistry, { description: "Printer group ID." }),
		format: n.union([n.enum(["A4", "A6"]), n.string()]).register(n.globalRegistry, { description: "Designated format of the printer." })
	}).register(n.globalRegistry, { description: "Body for unassigning a printer from a printer group." }),
	path: n.never().optional(),
	query: n.never().optional()
});
var V = n.void().register(n.globalRegistry, { description: "The printer has been unassigned." }), H = (e) => (e?.client ?? S).get({
	requestValidator: async (e) => await le.parseAsync(e),
	responseValidator: async (e) => await M.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/printer-groups",
	...e
}), U = (e) => (e?.client ?? S).get({
	requestValidator: async (e) => await ue.parseAsync(e),
	responseValidator: async (e) => await N.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}],
	url: "/printers",
	...e
}), W = (e) => (e?.client ?? S).get({
	requestValidator: async (e) => await de.parseAsync(e),
	responseValidator: async (e) => await P.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}],
	url: "/status",
	...e
}), G = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await fe.parseAsync(e),
	responseValidator: async (e) => await F.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}],
	url: "/allow-shops-access-to-printer-group",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), K = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await C.parseAsync(e),
	responseValidator: async (e) => await I.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}],
	url: "/assign-printer-to-group",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), q = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await w.parseAsync(e),
	responseValidator: async (e) => await L.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}],
	url: "/create-printer-group",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), J = (e) => (e?.client ?? S).post({
	requestValidator: async (e) => await T.parseAsync(e),
	responseValidator: async (e) => await R.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}],
	url: "/enable-direct-printing",
	...e
}), Y = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await E.parseAsync(e),
	responseValidator: async (e) => await z.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}],
	url: "/remove-printer-group",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), X = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await D.parseAsync(e),
	responseValidator: async (e) => await B.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}],
	url: "/rename-printer-group",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Z = (e) => (e?.client ?? S).post({
	requestValidator: async (e) => await O.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}],
	url: "/sync-printers",
	...e
}), Q = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await k.parseAsync(e),
	responseValidator: async (e) => await V.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}],
	url: "/unassign-printer-from-group",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
});
S.interceptors.error.use((e, t) => {
	if (t && typeof t == "object" && "status" in t) {
		let n = t.status;
		return e && typeof e == "object" ? {
			...e,
			status: n
		} : { status: n };
	}
	return e;
});
var pe = () => S.getConfig().auth, me = (n = { token: void 0 }) => {
	if (!n.token) throw Error("Token is required");
	let r = {
		baseUrl: e,
		auth: n.token
	};
	return n.environment && n.environment === "acceptance" && (r.baseUrl = t), n.locale && (r.headers = {
		...r.headers,
		"Accept-Language": n.locale
	}), S.setConfig(r), n.token;
}, he = (e) => {
	S.setConfig({ headers: {
		...S.getConfig().headers,
		"Accept-Language": e
	} });
}, ge = async () => (await U()).data, _e = async () => (await H()).data, ve = async () => (await J()).data, ye = async () => (await W()).data, be = async () => (await Z()).data, $ = async (e) => (await q({ body: e })).data, xe = async (e) => (await K({ body: e })).data, Se = async (e) => (await Y({ body: e })).data, Ce = async (e) => (await G({ body: e })).data, we = async (e) => (await Q({ body: e })).data, Te = async (e) => (await X({ body: e })).data;
function Ee() {
	return {
		getPrinterGroups: _e,
		getPrinters: ge,
		getStatus: ye,
		getToken: pe,
		initClient: me,
		postAllowShopsAccessToPrinterGroup: Ce,
		postAssignPrinterToGroup: xe,
		postCreatePrinterGroup: $,
		postEnableDirectPrinting: ve,
		postRemovePrinterGroup: Se,
		postRenamePrinterGroup: Te,
		postSyncPrinters: be,
		postUnassignPrinterFromGroup: we,
		setAcceptLanguageHeader: he
	};
}
//#endregion
export { G as a, J as c, Z as d, Q as f, W as i, Y as l, H as n, K as o, S as p, U as r, q as s, Ee as t, X as u };
